import { createRouter } from '@tanstack/react-router';
import * as TanStackQueryProvider from '@/integrations/tanstack-query/root-provider.tsx';
import { layoutRoute, rootRoute } from '@/router/root-routes.tsx';
import { productRoutes } from '@/app/products/product-routes.tsx';
import { staticPageRoutes } from '@/router/static-page-routes.tsx';
import { accountRoutes } from '@/app/account/account-routes.tsx';
import { AppNotFound } from '@/components/app/app-not-found.tsx';

const layoutRoutes = layoutRoute.addChildren([
  ...staticPageRoutes, ...productRoutes, ...accountRoutes
]);

const routeTree = rootRoute.addChildren([layoutRoutes]);

const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProvider.getContext(),
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultNotFoundComponent: AppNotFound,
});

declare module '@tanstack/react-router' {
  // noinspection JSUnusedGlobalSymbols
  interface Register {
    router: typeof router;
  }
}

export { router };
